// extracted by mini-css-extract-plugin
export default {"container":"FAQs--container--347f92","header":"FAQs--header--84c527","question":"FAQs--question--89db29"};